import { roundOffToTwoDecimals } from "./NumberUtils";

export const calculateRoi = (revenue, campaignCost) => {
    if (campaignCost === 0 || campaignCost == null) {
        return revenue > 0 ? "Infinity" : 0;
    }
    return roundOffToTwoDecimals(((revenue - campaignCost) / campaignCost) * 100);
};

export const calculateCampaignROIData = (campaign, options = {}) => {
    const totalCollections = campaign?.reportData?.totalCollections ?? 0;
    const totalMessagesSent = campaign?.reportData?.totalMessagesSent ?? 0;
    const costPerMessage = options.costPerMessage ?? campaign?.costPerMessage ?? 0;
    const amountPerPoint =
        campaign?.merchantPointRule?.ruleData?.amountPerPoint ||
        campaign?.defaultMerchPointRule?.ruleData?.amountPerPoint ||
        options.defaultMerchPointRule?.ruleData?.amountPerPoint ||
        0;

    const revenueFromPoints = roundOffToTwoDecimals(
        totalCollections * amountPerPoint
    ) ?? 0;

    const totalCampaignCost = roundOffToTwoDecimals(
        totalMessagesSent * costPerMessage
    ) ?? 0;

    return {
        revenueFromPoints,
        totalCampaignCost,
    };
};

export const getFormattedROIValue = (campaign, isGoalDriven) => {
    if (!isGoalDriven) return "N/A";

    const { revenueFromPoints, totalCampaignCost } = calculateCampaignROIData(campaign);
    const calculatedRoi = calculateRoi(revenueFromPoints, totalCampaignCost);

    return calculatedRoi === "Infinity" ? "Infinity%" : `${calculatedRoi}%`;
};

export const calculateAvgPointsPerMember = (reportData) => {
    const totalCollections = reportData?.totalCollections ?? 0;
    const membersCollectedPoints = reportData?.membersCollectedPoints ?? 0;

    if (membersCollectedPoints === 0 || membersCollectedPoints == null) {
        return 0;
    }

    return roundOffToTwoDecimals(totalCollections / membersCollectedPoints);
};

